import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import titleMixin from '@/mixins/titleMixin'

Vue.mixin(titleMixin)
Vue.use(BootstrapVue)
Vue.use(VueCookies)
Vue.$cookies.config('7d','/','.x-orsystem.com', true, 'None')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
